// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"216":"13f1a110","311":"235c42b2"}[chunkId] + ".chunk.css";
};